module.exports = __webpack_public_path__ + "img/feel-logo.9367f472.png";